import React, { Component } from "react";
import {
  PageHeader,
  Row,
  Col,
  DatePicker,
  Button,
  Radio,
  message,
  Select,
  Modal,
  Input,
  Popconfirm,
  Divider,
  Form,
  Collapse,
  Badge,
  Tooltip,
  Alert,
} from "antd";
import {
  RedoOutlined,
  StarOutlined,
  TagsOutlined,
  DeleteOutlined,
  HighlightOutlined,
  CheckCircleOutlined,
  StarTwoTone,
  DownOutlined,
  UpOutlined,
  StarFilled,
} from "@ant-design/icons";
import { withRouter } from "next/router";
import Statistics from "./components/Statistics";
import SalesChart from "./components/SalesChart";
import PieChart from "./components/PieChart";
import LineChart from "./components/LineChart";
import HistogramChart from "./components/HistogramChart";
import HistoricalChart from "./components/HistoricalChart";
import LabelChart from "./components/LabelChart";
// import RecentTransaction from "./components/RecentTransaction";
import Cookie from "universal-cookie";
import { ScreenSize } from "utils/constants";
import {
  adviseeBirthday,
  adviseeStatistic,
  adviseeChart,
} from "apis/dashboard";
import moment from "moment";
import Title from "components/Title/Title";
import BirthdayList from "./components/BirthdayList";
import { withAppContext } from "contexts/AppContext/AppContext";
import { buildBillingSubscriptionUri, buildBillingUri } from "utils/routes";
import { assignFreeTrial } from "apis/billing";
import Locale from "react-intl-universal";

const { Panel } = Collapse;
class Dashboard extends Component {
  state = {
    freeTrialModalVisible: false,
    firstTimeUserSubscriptionModalVisible: false,
    subscriptionModalWarningVisible: false,
    userSubscription: [],
    paymentOverdueWarningAlert: false,
    loading: false,
    selectYear: moment(),
    dateRange: [
      moment().subtract(7, "day").startOf("day"),
      // moment().subtract(1, "month"),
      moment().endOf("day"),
    ],

    birthdayList: [
      // {
      //   fullName: 'Jayden Lee',
      //   dateOfBirth: moment().subtract(30, 'years'),
      //   age: 30,
      //   contact: '+60167029397',
      //   category: 'Client'
      // },
      // {
      //   fullName: 'John doe',
      //   dateOfBirth: moment().subtract(25, 'years'),
      //   age: 33,
      //   contact: '+60135456789',
      //   category: 'Advisee'
      // }
    ],

    statistic: {
      totalNewAdvisee: 0,
      totalAdvisee: 0,
      totalDeal: 0,
      totalClient: 0,
    },

    lineChartData: {
      newAdvisee: [
        {
          month: "Jan",
          newAdvisee: 12,
        },
        {
          month: "Feb",
          newAdvisee: 30,
        },
        {
          month: "Mar",
          newAdvisee: 24,
        },
        {
          month: "Apr",
          newAdvisee: 16,
        },
        {
          month: "May",
          newAdvisee: 11,
        },
        {
          month: "Jun",
          newAdvisee: 15,
        },
        {
          month: "Jul",
          newAdvisee: 17,
        },
        {
          month: "Aug",
          newAdvisee: 16,
        },
        {
          month: "Sep",
          newAdvisee: 23,
        },
        {
          month: "Oct",
          newAdvisee: 18,
        },
        {
          month: "Nov",
          newAdvisee: 13,
        },
        {
          month: "Dec",
          newAdvisee: 9,
        },
      ],
      totalAdvisee: [
        {
          month: "Jan",
          advisee: 5,
        },
        {
          month: "Feb",
          advisee: 10,
        },
        {
          month: "Mar",
          advisee: 15,
        },
        {
          month: "Apr",
          advisee: 20,
        },
        {
          month: "May",
          advisee: 25,
        },
        {
          month: "Jun",
          advisee: 30,
        },
        {
          month: "Jul",
          advisee: 25,
        },
        {
          month: "Aug",
          advisee: 20,
        },
        {
          month: "Sep",
          advisee: 15,
        },
        {
          month: "Oct",
          advisee: 10,
        },
        {
          month: "Nov",
          advisee: 5,
        },
        {
          month: "Dec",
          advisee: 18,
        },
      ],
      deals: [
        {
          month: "Jan",
          deals: 7,
        },
        {
          month: "Feb",
          deals: 4,
        },
        {
          month: "Mar",
          deals: 15,
        },
        {
          month: "Apr",
          deals: 21,
        },
        {
          month: "May",
          deals: 5,
        },
        {
          month: "Jun",
          deals: 28,
        },
        {
          month: "Jul",
          deals: 11,
        },
        {
          month: "Aug",
          deals: 17,
        },
        {
          month: "Sep",
          deals: 8,
        },
        {
          month: "Oct",
          deals: 22,
        },
        {
          month: "Nov",
          deals: 27,
        },
        {
          month: "Dec",
          deals: 13,
        },
      ],
      client: [
        {
          month: "Jan",
          clients: 30,
        },
        {
          month: "Feb",
          clients: 24,
        },
        {
          month: "Mar",
          clients: 15,
        },
        {
          month: "Apr",
          clients: 17,
        },
        {
          month: "May",
          clients: 7,
        },
        {
          month: "Jun",
          clients: 14,
        },
        {
          month: "Jul",
          clients: 8,
        },
        {
          month: "Aug",
          clients: 19,
        },
        {
          month: "Sep",
          clients: 11,
        },
        {
          month: "Oct",
          clients: 3,
        },
        {
          month: "Nov",
          clients: 25,
        },
        {
          month: "Dec",
          clients: 10,
        },
      ],
    },
  };

  formRef = React.createRef();

  componentDidMount() {
    this.mounted = true;
    // console.log(this.props);
    console.log("this.props", this.props);

    // setTimeout(() => {
    //   this.setState({
    //     statistic: {
    //       totalNewAdvisee: 123,
    //       totalAdvisee: 456,
    //       totalDeal: 789,
    //       totalClient: 523
    //     }
    //   });
    // }, 2000);
    this.getUserSubscription();
    this.BirthdayList();
    this.StatisticList(moment().format("YYYY"));
    this.AdviseeChart(moment().format("YYYY"));

    // this.GetDashboard();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  // GetDashboard = async () => {
  //   message.loading('Loading data...');
  //   this.setState({ loading: true });
  //   const res = await DashboardApi.getDashboardData(
  //     this.state.dateRange[0].unix(),
  //     this.state.dateRange[1].unix()
  //   );
  //   console.log(res);

  //   if (res) {
  //     // custom chart data
  //     let RevenueChart = [];
  //     let RefundChart = [];

  //     for (let i = 0; i < res.revenueChart.length; i++) {
  //       RevenueChart.push({
  //         amount: res.revenueChart[i].sumOfAmount / 100,
  //         day:
  //           res.revenueChart[i].day +
  //           '/' +
  //           res.revenueChart[i].month +
  //           '/' +
  //           res.revenueChart[i].year,
  //         count: res.revenueChart[i].count
  //       });
  //     }

  //     for (let i = 0; i < res.refundChart.length; i++) {
  //       RefundChart.push({
  //         amount: res.refundChart[i].sumOfAmount / 100,
  //         day:
  //           res.refundChart[i].day +
  //           '/' +
  //           res.refundChart[i].month +
  //           '/' +
  //           res.refundChart[i].year,
  //         count: res.refundChart[i].count
  //       });
  //     }

  //     message.destroy();
  //     this.setState({
  //       loading: false,
  //       dashboard_data: {
  //         statistic: {
  //           commission: res.commission,
  //           refund: res.refund,
  //           reload: res.reload,
  //           revenue: res.revenue
  //         },
  //         chart: {
  //           revenueChart: RevenueChart,
  //           refundChart: RefundChart
  //         }
  //       }
  //     });
  //   }

  //   // if (res.status === 200) {
  //   //   message.destroy();
  //   //   this.setState({
  //   //     loading: false,
  //   //     dashboard_data: res.data
  //   //   });
  //   // } else {
  //   //   message.destroy();
  //   //   this.setState({ loading: false });
  //   //   ResponseError(res);
  //   // }
  // };

  getUserSubscription = async () => {
    const userSubscription = await this.props.getLoggedInUserSubscription();
    const user = this.props.getLoggedInUser();

    if (userSubscription.length > 0) {
      this.setState({
        userSubscription: userSubscription,
      });
      if (
        userSubscription[0].subscriptionStatus === "past_due" &&
        userSubscription[0].paid === false
      ) {
        this.setState({
          subscriptionModalWarningVisible: true,
          paymentOverdueWarningAlert: true,
        });
      }
    } else {
      if (this.props.isAdmin) {
        this.setState({
          firstTimeUserSubscriptionModalVisible: false,
        });
      } else {
        if (user.subscriptionStartDate && user.subscriptionEndDate) {
          const subscriptionStartDate = parseInt(user.subscriptionStartDate);
          const subscriptionEndDate = parseInt(user.subscriptionEndDate);
          const now = Math.floor(Date.now() / 1000);

          if (subscriptionEndDate >= now && subscriptionStartDate <= now) {
            this.setState({
              freeTrialModalVisible: false,
              firstTimeUserSubscriptionModalVisible: false,
            });
          } else {
            this.setState({
              freeTrialModalVisible: false,
              firstTimeUserSubscriptionModalVisible: true,
            });
          }
        } else {
          this.setState({
            freeTrialModalVisible: true,
            firstTimeUserSubscriptionModalVisible: false,
          });
        }
      }
    }
  };

  BirthdayList = async () => {
    const res = await adviseeBirthday();
    // console.log("birthday", res);

    this.setState({
      birthdayList: res,
    });
  };

  StatisticList = async (e) => {
    const res = await adviseeStatistic(e);
    console.log("adviseeStatistic", res);

    this.setState({
      statistic: res,
    });
  };

  AdviseeChart = async (e) => {
    const res = await adviseeChart(e);
    console.log("adviseeChart", res);

    this.setState({
      lineChartData: res,
    });
  };

  SubscriptionModalWarning = () => {
    return (
      <Modal
        closable
        title="Subscription Payment Overdue!"
        visible={this.state.subscriptionModalWarningVisible}
        onOk={() => {
          this.setState({
            subscriptionModalWarningVisible: false,
          });
          window.location.assign(buildBillingUri());
        }}
        cancelButtonProps={{ style: { display: "none" } }}
        onCancel={() => {
          this.setState({
            subscriptionModalWarningVisible: false,
          });
        }}
      >
        <div
          style={{
            fontWeight: "500",
          }}
        >
          We regret to inform you that your subscription is currently overdue.
          To ensure uninterrupted access to our services, we kindly request that
          you update your payment information by visiting the Billing Page.
        </div>
        <br />
        <div
          style={{
            fontWeight: "500",
          }}
        >
          Please note that if you fail to update your payment information by{" "}
          {moment
            .unix(this.state.userSubscription[0]?.startDate)
            .add(15, "days")
            .format("YYYY-MM-DD")}{" "}
          (15 days after your supposed renewal date, which was on{" "}
          {moment
            .unix(this.state.userSubscription[0]?.startDate)
            .format("YYYY-MM-DD")}
          ), our system will automatically cancel your subscription. This will
          result in the loss of your current subscription and access to our
          services.
        </div>
        <br />
        <div
          style={{
            fontWeight: "500",
          }}
        >
          If you require any assistance or have any questions, please do not
          hesitate to contact our customer service team. We are available to
          help you resolve any issues you may have.
        </div>
        <br />
        <div
          style={{
            fontWeight: "500",
          }}
        >
          An email has also been sent to you regarding this issue, so please
          check your inbox for more information.
        </div>
      </Modal>
    );
  };

  FirstTimeUserSubscriptionModalWarning = () => {
    return (
      <Modal
        closable
        title="Welcome to Finport!"
        visible={this.state.firstTimeUserSubscriptionModalVisible}
        onOk={() => {
          this.setState({
            firstTimeUserSubscriptionModalVisible: false,
          });
          window.location.assign(buildBillingSubscriptionUri());
        }}
        cancelButtonProps={{ style: { display: "none" } }}
        onCancel={() => {
          this.setState({
            firstTimeUserSubscriptionModalVisible: false,
          });
        }}
      >
        <div
          style={{
            fontWeight: "500",
          }}
        >
          We noticed that you haven't subscribed to any of our plans yet, and
          we'd like to invite you to take advantage of all our website has to
          offer.
        </div>
        <br />
        <div
          style={{
            fontWeight: "500",
          }}
        >
          To continue enjoying our website's full range of features, we kindly
          invite you to subscribe to one of our plans that best suits your
          needs. Please visit the Billing Page to get started.
        </div>
        <br />
        <div
          style={{
            fontWeight: "500",
          }}
        >
          Our exceptional customer service team is here to assist you with any
          questions or concerns you may have.
        </div>
        <br />
        <div
          style={{
            fontWeight: "500",
          }}
        >
          Thank you for considering our subscription plans. We look forward to
          serving you.
        </div>
      </Modal>
    );
  };

  FreeTrialModalWarning = () => {
    return (
      <Modal
        closable
        title="Welcome to Finport!"
        width={640}
        bodyStyle={{
          backgroundColor: "#FBFBFB",
        }}
        visible={this.state.freeTrialModalVisible}
        okText="Start Trial"
        onOk={() => {
          this.setState({
            freeTrialModalVisible: false,
          });

          const subscriptionStartDate = moment().unix();
          const subscriptionEndDate = moment
            .unix(subscriptionStartDate)
            .add(2, "weeks")
            .unix();

          Modal.confirm({
            width: 640,
            content: `The trial period will start on ${moment
              .unix(subscriptionStartDate)
              .format("YYYY-MM-DD h:mm A")} and end on ${moment
              .unix(subscriptionEndDate)
              .format("YYYY-MM-DD h:mm A")}.`,
            title:
              "Are you sure you want to activate your two weeks free trial now?",
            onOk: async () => {
              assignFreeTrial()
                .then((res) => {
                  if (res.status === 200) {
                    message.success(
                      "Congratulations! Your Finport exclusive two weeks free trial has been successfully activated. Enjoy!"
                    );
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  }
                })
                .catch((ex) => {
                  Modal.error({
                    title: ex.message,
                  });
                });
            },
          });
        }}
        cancelButtonProps={{ style: { display: "none" } }}
        onCancel={() => {
          this.setState({
            freeTrialModalVisible: false,
          });
        }}
      >
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          {/* <img
            src="https://fastfix247.com/topic/wp-content/uploads/2021/11/free-trial.gif"
            alt="Animated GIF"
          ></img> */}
          <img src="/free-trial.gif" alt="Animated GIF"></img>
        </div>

        <div
          style={{
            fontWeight: "500",
            textAlign: "center",
            fontSize: 15,
          }}
        >
          Experience the unparalleled benefits of Finport with a seamless
          initiation:
        </div>

        <div
          style={{
            fontWeight: "500",
            textAlign: "center",
            fontSize: 16,
          }}
        >
          simply click the "Start Trial" button to embark on your free{" "}
          <b>two weeks</b> trial.
        </div>
      </Modal>
    );
  };

  render() {
    return (
      <div>
        {this.state.paymentOverdueWarningAlert && (
          <Row justify="center" align="middle">
            <Alert
              style={{ width: "100%" }}
              message="Subscription Payment Overdue"
              showIcon
              description={`Update payment info now to avoid service interruption. Don't miss out on the benefits of your subscription.`}
              type="error"
            />
          </Row>
        )}
        <Row
          align="middle"
          justify="space-between"
          style={{ marginBottom: 32 }}
        >
          <Col>
            <Row>
              <Title /* marginBottom="32px" */>
                {Locale.get("Dashboard.pageTitle")}
              </Title>
            </Row>

            <Row>
              <DatePicker
                value={this.state.selectYear}
                disabledDate={(e) => e && e > moment().endOf("year")}
                onChange={(e) => {
                  console.log(e);

                  if (e !== null) {
                    this.StatisticList(moment(e).format("YYYY"));
                    this.AdviseeChart(moment(e).format("YYYY"));

                    this.setState({
                      selectYear: e,
                    });
                  } else {
                    this.StatisticList(moment().format("YYYY"));
                    this.AdviseeChart(moment().format("YYYY"));

                    this.setState({
                      selectYear: moment(),
                    });
                  }
                }}
                picker="year"
              />
            </Row>
          </Col>

          <Col>
            <Row
              justify="end"
              style={{
                fontSize: 24,
                fontWeight: 500,
                color: "rgba(0,0,0,0.55)",
              }}
            >
              {Locale.get("Dashboard.todaysDate")}
            </Row>
            <Row
              justify="end"
              style={{ fontSize: 18, fontWeight: 500, color: "black" }}
            >
              {moment().format("dddd, Do MMMM YYYY")}
            </Row>
          </Col>
        </Row>
        <BirthdayList data={this.state.birthdayList} />
        <Statistics data={this.state.statistic} />

        {/* <div
              style={{
                backgroundColor: "#fff",
                padding: 16,
                borderRadius: 10
              }}
            > */}
        <LineChart data={this.state.lineChartData} />
        {/* </div> */}
        {this.SubscriptionModalWarning()}
        {this.FirstTimeUserSubscriptionModalWarning()}
        {this.FreeTrialModalWarning()}
      </div>
    );
  }
}

export default withAppContext(Dashboard);
